import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { postDataAPI } from '../Helpers/FetchAPI';

export const useImpersonationFromUrl = (setImpersonateEmail, handleUserViewChange) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const impersonateToken = searchParams.get('impersonate');

    if (!impersonateToken) {
      return;
    }

    postDataAPI('/user/validate-impersonation', { token: impersonateToken }, {
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include' // Include auth cookies
    })
      .then(data => {
        const { valid, email } = data.data;
        if (valid && email) {
          handleUserViewChange(false);
          setImpersonateEmail(email);
        }
      })
      .catch(error => {
        console.error('Impersonation validation failed:', error.message);
      })
      .finally(() => {
        searchParams.delete('impersonate');
        setSearchParams(searchParams, { replace: true });
      });
  }, [searchParams, setSearchParams, setImpersonateEmail, handleUserViewChange]);
}